<template>
  <div id="myLogin">
    <el-dialog custom-class="dialog-login" :show-close="false" width="600px" :close-on-click-modal="true" center
               :visible.sync="isLogin">
      <div class="dialog-content">
        <div class="dialog-content-left">
          <div class="dialog-content-left-name">
            <p>欢迎登录</p>
            <p>智慧生活10000号</p>
          </div>
        </div>
        <div class="dialog-content-right">
          <div v-if="changeShow">
            <div v-show="currentLoginType != 'register'"
                 style="padding-bottom: 0.625rem;display: flex;justify-content: center;font-weight: bold;color: #000000;"
                 @click="changeLoginTypeHangle(0)"><img :src="loginType[0].img"
                                                        style="width: 1.25rem;height: 1.25rem;margin-right: 0.625rem;"/>
              <div v-show="currentLoginType != 'rPassword'">{{ loginType[0].label }}</div>
              <div v-show="currentLoginType == 'rPassword'">找回密码</div>
            </div>
            <div v-show="currentLoginType == 'register'"
                 style="padding-bottom: 0.625rem;display: flex;justify-content: center;font-weight: bold;color: #000000;"
            >
              <div>帐号密码注册并登录</div>
            </div>
            <!--            手机验证码登录-->
            <div style="position: relative;top: 20px;" v-show="currentLoginType == 'mobile'">
              <el-form :model="loginUser" :rules="rules" status-icon ref="ruleForm" class="demo-ruleForm">
                <el-form-item prop="phone">
                  <el-input prefix-icon="el-icon-user-solid" placeholder="请输入手机号"
                            v-model="loginUser.phone"></el-input>
                </el-form-item>
                <el-form-item prop="code">
                  <el-input prefix-icon="el-icon-view" placeholder="请输入验证码" v-model="loginUser.code">
                    <el-button slot="append" @click="getCodeHandle" :disabled="getCode"> {{ getCodeText }}</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="medium" id="submit-id" type="primary" @click="Login" :loading="btnLoading"
                             style="width:100%;">登录
                  </el-button>
                </el-form-item>
              </el-form>
            </div>

            <!--            账密-->
            <div style="position: relative;top: 20px;" v-show="currentLoginType == 'pwd'">
              <el-form :model="loginPwdUser" :rules="pwdRules" status-icon ref="rulePwdForm" class="demo-ruleForm">
                <el-form-item prop="account">
                  <el-input prefix-icon="el-icon-user-solid" placeholder="请输入帐号"
                            v-model="loginPwdUser.account"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input prefix-icon="el-icon-lock" show-password placeholder="请输入密码"
                            v-model="loginPwdUser.password"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom: 10px;">
                  <el-button id="submit-id" size="medium" :loading="btnLoading" type="primary" @click="PwdLogin"
                             style="width:100%;">登录
                  </el-button>
                </el-form-item>
              </el-form>
              <div style="display: flex;align-items: center;justify-content: space-between;font-size: 12px;">
                <div style="color: #409EFF;" @click="registerHandle">立即注册</div>
                <div style="color: #409EFF;" @click="rPassword">忘记密码</div>
              </div>
            </div>

            <!--            注册-->
            <div style="position: relative;top: 3px;" v-show="currentLoginType == 'register'">
              <el-form :model="registerPwdUser" :rules="registerRules" status-icon ref="ruleRegisterForm"
                       class="demo-ruleForm">



                <el-form-item prop="account">
                  <el-input prefix-icon="el-icon-user-solid" placeholder="输入帐号用于登录"
                            v-model="registerPwdUser.account"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input prefix-icon="el-icon-lock" placeholder="请输入密码" show-password
                            v-model="registerPwdUser.password"></el-input>
                </el-form-item>
                <el-form-item prop="comfirePassword">
                  <el-input prefix-icon="el-icon-lock" placeholder="请输入确认密码" show-password
                            v-model="registerPwdUser.comfirePassword"></el-input>
                </el-form-item>

                <el-form-item prop="phone">
                  <el-input prefix-icon="el-icon-user-solid" placeholder="请输入手机号"
                            v-model="registerPwdUser.phone"></el-input>
                </el-form-item>

                <el-form-item prop="code">
                  <el-input prefix-icon="el-icon-view" placeholder="请输入验证码" v-model="registerPwdUser.code">
                    <el-button slot="append" @click="getCodeInReg" :disabled="getCode2"> {{ getCodeText2 }}</el-button>                  </el-input>
                </el-form-item>

                <el-form-item style="margin-bottom: 10px;">
                  <el-button size="medium" id="submit-id" type="primary" @click="registerSubmit" style="width:100%;"
                             :loading="btnLoading">注册并登录
                  </el-button>
                </el-form-item>
              </el-form>
              <div style="display: flex;align-items: center;justify-content: space-between;font-size: 12px;">
                <div style="color: #409EFF;" @click="changeLoginTypeHangle(0)">返回登录</div>
              </div>
            </div>

            <!--            找回密码-->
            <div style="position: relative;top: 3px;" v-show="currentLoginType == 'rPassword'">
              <el-form :model="reUser" :rules="reUserRules" status-icon class="demo-reUser">
                <el-form-item prop="account">
                  <el-input prefix-icon="el-icon-user-solid" placeholder="请输入找回账号"
                            v-model="reUser.account"></el-input>
                </el-form-item>
                <el-form-item prop="phone">
                  <el-input prefix-icon="el-icon-user-solid" placeholder="请输入手机号"
                            v-model="reUser.phone"></el-input>
                </el-form-item>
                <el-form-item prop="code">
                  <el-input prefix-icon="el-icon-view" placeholder="请输入验证码" v-model="reUser.code">
                    <el-button slot="append" @click="getCodeByPassword" :disabled="getCode1"> {{ getCodeText1 }}
                    </el-button>
                  </el-input>
                </el-form-item>
                <el-form-item prop="newPassword">
                  <el-input prefix-icon="el-icon-user-solid" placeholder="请输入新密码"
                            v-model="reUser.newPassword"></el-input>
                </el-form-item>
                <el-form-item prop="newPassword1">
                  <el-input prefix-icon="el-icon-user-solid" placeholder="请输入新密码"
                            v-model="reUser.newPassword1"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="medium" id="submit-id" type="primary" @click="rePassword" :loading="btnLoading"
                             style="width:100%;">重置密码
                  </el-button>
                </el-form-item>
              </el-form>
              <div style="display: flex;align-items: center;justify-content: space-between;font-size: 12px;">
                <div style="color: #409EFF;" @click="changeLoginTypeHangle(0)">返回登录</div>
              </div>
            </div>

            <!--            登录方式选择-->
            <div v-show="currentLoginType != 'register'" v-if="currentLoginType != 'rPassword'"
                 style="display: flex;justify-content: space-between;align-items: center;padding-top: 1.25rem;">
              <div style="display: flex;align-items: center;" @click="changeLoginTypeHangle(1)">
                <img :src="loginType[1].img" style="width: 20px;height: 20px;padding: 10px;"/>
                <div style="font-size: 12px;">{{ loginType[1].typeName }}</div>
              </div>
              <div style="display: flex;align-items: center;" @click="changeLoginTypeHangle(2)">
                <img :src="loginType[2].img" style="width: 20px;height: 20px;padding: 10px;"/>
                <div style="font-size: 12px;">{{ loginType[2].typeName }}</div>
              </div>
              <div style="display: flex;align-items: center;" @click="changeLoginTypeHangle(3)">
                <img :src="loginType[3].img" style="width: 20px;height: 20px;padding: 10px;"/>
                <div style="font-size: 12px;">{{ loginType[3].typeName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 图形验证码弹窗 -->
    <div v-if="captchaVisible" class="captcha-overlay">
      <div class="captcha-box">
        <p class="captcha-title">请输入图形验证码</p>
        <div class="captcha-img-row">
          <img :src="captchaImg" @click="refreshCaptcha" class="captcha-img" title="点击刷新" />
          <span @click="refreshCaptcha" class="captcha-refresh">换一张</span>
        </div>
        <el-input v-model="captchaInput" placeholder="请输入验证码"
                  @keyup.enter.native="confirmCaptcha" class="captcha-input"></el-input>
        <div class="captcha-btns">
          <el-button size="small" @click="cancelCaptcha">取消</el-button>
          <el-button size="small" type="primary" @click="confirmCaptcha">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions
} from "vuex";
import {
  setToken
} from '@/utils/auth'
import {
  getUserLoginPhoneCode,
  accountCodeLogin,
  accountQQLogin,
  getWechatQrCode,
  wxCallBack,
  accountPwdRegister,
  accountPwdLogin, getCodeImg, PasswordSet
} from "@/api/loginApi"
import {getUrlParams} from "@/utils/strUtil"

export default {
  name: "MyLogin",
  data() {
    // 用户名的校验方法
    let validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      }
      // 用户名以字母开头,长度在5-16之间,允许字母数字下划线
      const userNameRule = /^[\d]{11}$/;
      if (!userNameRule.test(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      return callback();
    };
    // 验证码的校验方法
    let validateCode = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入验证码"));
      }
      return callback();
    };
    // 账号的校验方法
    let validateAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入帐号"));
      }
      return callback();
    };
    // 密码的校验方法
    let validatePwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入密码"));
      }
      return callback();
    };
    let validateNewPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入新密码"));
      }
      return callback();
    };
    let validateComfirePwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入确认密码"));
      }
      const passwordRule = /^.{6,20}$/;
      if (!passwordRule.test(value)) {
        return callback(new Error("密码长度为6-20个字符长度"));
      }
      if (this.registerPwdUser.password != value) {
        return callback(new Error("两次输入密码不一致"));
      }
      return callback();
    }

    let newPasswordSure = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入确认密码"));
      }
      const passwordRule = /^.{6,20}$/;
      if (!passwordRule.test(value)) {
        return callback(new Error("密码长度为6-20个字符长度"));
      }
      if (this.reUser.newPassword != value) {
        return callback(new Error("两次输入密码不一致"));
      }
      return callback();
    }

    return {
      getCode: false, // 控制1分钟内才能进行再次发送验证码
      getCode1: false, // 控制1分钟内才能进行再次发送验证码
      getCode2: false, // 控制1分钟内才能进行再次发送验证码
      getCodeText: "获取验证码", // 默认显示文字
      getCodeText1: "获取验证码", // 默认显示文字
      getCodeText2: "获取验证码", // 默认显示文字
      // 图形验证码
      captchaVisible: false,
      captchaImg: '',
      captchaUuid: '',
      captchaInput: '',
      captchaCallback: null,
      // 独立定时器（修复共享 timer 缺陷）
      timerLogin: null,
      timerPassword: null,
      timerReg: null,
      btnLoading: false, //转圈
      changeShow: true,
      loginType: [{
        label: '手机验证码登录',
        typeName: '手机登录/注册',
        type: 'mobile',
        img: '/img/mobile.png'
      }, {
        label: '微信扫码登录',
        typeName: '微信登录/注册',
        type: 'wx',
        img: '/img/wx.png'
      },
        {
          label: 'QQ扫码登录',
          typeName: 'QQ登录/注册',
          type: 'qq',
          img: '/img/qq.png'
        },
        {
          label: '帐号密码登录',
          typeName: '帐号登录/注册',
          type: 'pwd',
          img: '/img/pwd.png'
        }
      ],
      currentLoginType: 'mobile',
      loginUser: {
        phone: "",
        code: ""
      },
      reUser: {
        account: '',//账号
        phone: '',
        code: '',
        newPassword: '',
        newPassword1:'',//再次输入密码
      },
      reUserRules: {
        account: [{
          validator: validateAccount,
          trigger: "blur"
        }],
        phone: [{
          validator: validatePhone,
          trigger: "blur"
        }],
        code: [{
          validator: validateCode,
          trigger: "blur"
        }],
        newPassword: [{
          validator: validateNewPwd,
          trigger: "blur"
        }],
        newPassword1:[{
          validator: newPasswordSure,
          trigger: "blur"
        }]
      },

      // 用户信息校验规则,validator(校验方法),trigger(触发方式),blur为在组件 Input 失去焦点时触发
      rules: {
        phone: [{
          validator: validatePhone,
          trigger: "blur"
        }],
        code: [{
          validator: validateCode,
          trigger: "blur"
        }]
      },
      loginPwdUser: {
        account: "",
        password: ""
      },
      pwdRules: {
        account: [{
          validator: validateAccount,
          trigger: "blur"
        }],
        password: [{
          validator: validatePwd,
          trigger: "blur"
        }]
      },
      qc: null,
      options: {
        appId: 102060115, //这个appId 是这个demo的，业务请使用自己的appid
        //s_url 这个参数业务可以自定，目的是让业务在回调页知道怎么回调到发起登录的页面
        // redirectURI: 'https://zmsk.zhsh10000.com/#/abc'
        redirectURI: 'https://www.zhsh10000.com/#/abc'
      },
      registerPwdUser: {
        phone: '',  // 找回账号需要绑定手机
        code:'',//验证码
        account: '',
        password: '',
        comfirePassword: ''
      },
      registerRules: {
        phone: [{
          validator: validatePhone,
          trigger: "blur"
        }],
        account: [{
          validator: validateAccount,
          trigger: "blur"
        }],
        password: [{
          validator: validatePwd,
          trigger: "blur"
        }],
        comfirePassword: [{
          validator: validateComfirePwd,
          trigger: "blur"
        }]
      }
    };
  },
  computed: {
    // 获取vuex中的showLogin，控制登录组件是否显示
    isLogin: {
      get() {
        return this.$store.getters.getShowLogin;
      },
      set(val) {
        // this.$refs["ruleForm"].resetFields();
        // this.setShowLogin(val);
        location.reload();
      }
    }
  },
  mounted() {
    this.qc = QC
    this.init()

    let zhshLoginType = localStorage.getItem("zhshLoginType")
    if (zhshLoginType === 'wx') {
      let params = getUrlParams(window.location.href)
      location.hash = "#/"
      wxCallBack(params.code).then((res) => {
        if (res.code === 200) {
          // 隐藏登录组件
          this.isLogin = false;
          // 登录信息存到本地
          res.data.user.accessToken = res.data.token
          res.data.user.avatar = res.data.user.avatar ? (res.data.user.avatar.indexOf('http') >= 0 ? '' : this.$target) + res.data.user.avatar : '/img/head-sculpture.png'
          let user = JSON.stringify(res.data.user);
          localStorage.setItem("user", user);
          localStorage.removeItem("zhshLoginType")
          this.$emit("getUserNo", res.data.user.userNo)
          // 登录信息存到vuex
          setToken(res.data.token);
          this.setUser(res.data.user);
          // 弹出通知框提示登录成功信息
          this.notifySucceed(res.msg);
        } else {
          // 弹出通知框提示登录失败信息
          this.notifyError(res.data.msg);
        }
      })
    }

  },
  methods: {
    // 显示图形验证码弹窗
    async showCaptcha(callback) {
      this.captchaCallback = callback;
      this.captchaInput = '';
      this.captchaVisible = true;
      try {
        const res = await getCodeImg();
        if (res && res.img) {
          this.captchaImg = 'data:image/jpg;base64,' + res.img;
          this.captchaUuid = res.uuid;
        }
      } catch (e) {
        this.$message.error('获取验证码失败，请重试');
        this.captchaVisible = false;
      }
    },
    // 刷新验证码
    async refreshCaptcha() {
      try {
        const res = await getCodeImg();
        if (res && res.img) {
          this.captchaImg = 'data:image/jpg;base64,' + res.img;
          this.captchaUuid = res.uuid;
          this.captchaInput = '';
        }
      } catch (e) {
        this.$message.error('刷新验证码失败');
      }
    },
    // 确认验证码
    confirmCaptcha() {
      if (!this.captchaInput || this.captchaInput.trim() === '') {
        this.$message.warning('请输入图形验证码');
        return;
      }
      this.captchaVisible = false;
      if (this.captchaCallback) {
        this.captchaCallback(this.captchaUuid, this.captchaInput.trim());
      }
    },
    // 取消验证码
    cancelCaptcha() {
      this.captchaVisible = false;
      this.captchaInput = '';
    },
    registerSubmit() {
      this.$refs["ruleRegisterForm"].validate(valid => {
        if (valid) {
          this.btnLoading = true
          accountPwdRegister(this.registerPwdUser).then((res) => {
            this.btnLoading = false
            if (res.code === 200) {
              // 隐藏登录组件
              this.isLogin = false;
              // 登录信息存到本地
              res.data.user.accessToken = res.data.token
              res.data.user.avatar = res.data.user.avatar ? (res.data.user.avatar.indexOf('http') >= 0 ? '' : this.$target) + res.data.user.avatar : '/img/head-sculpture.png'
              let user = JSON.stringify(res.data.user);
              localStorage.setItem("user", user);
              this.$emit("getUserNo", res.data.user.userNo)
              // 登录信息存到vuex
              setToken(res.data.token);
              this.setUser(res.data.user);
              this.$refs["ruleRegisterForm"].resetFields();
              // 弹出通知框提示登录成功信息
              this.notifySucceed(res.msg);
            } else {
              this.$refs["ruleRegisterForm"].resetFields();
              // 弹出通知框提示登录失败信息
              this.notifyError(res.data.msg);
            }
          }).finally(res => {
            this.btnLoading = false
          })

          return true
        } else {
          return false
        }
      })
    },
    registerHandle() {
      this.currentLoginType = 'register'
    },
    rPassword() {
      this.currentLoginType = 'rPassword'
    },
    init() {
      const that = this
      // 判断QQ是否登录
      if (that.qc.Login.check()) {
        that.qc.Login.getMe(function (openId, accessToken) {
          that.qc.api("get_user_info").success(function (req) {
            location.hash = "#/"
            const loginQQUser = {
              openId: openId,
              nickName: req.data.nickname,
              avatar: req.data.figureurl_2
            }
            accountQQLogin(loginQQUser).then((res) => {
              if (res.code === 200) {
                // 隐藏登录组件
                that.isLogin = false;
                // 登录信息存到本地
                res.data.user.accessToken = res.data.token;
                res.data.user.avatar = res.data.user.avatar ? (res.data.user.avatar.indexOf('http') >= 0 ? '' : this.$target) + res.data.user.avatar : '/img/head-sculpture.png'
                let user = JSON.stringify(res.data.user);
                localStorage.setItem("user", user);
                that.$emit("getUserNo", res.data.user.userNo)
                // 登录信息存到vuex
                setToken(res.data.token);
                that.setUser(res.data.user);
                // 弹出通知框提示登录成功信息
                that.notifySucceed(res.msg);
              } else {
                // 弹出通知框提示登录失败信息
                this.notifyError(res.data.msg);
              }
            })
          })
        })
      }
    },
    ...mapActions(["setUser", "setShowLogin"]),
    // 登录获取验证码
    async getCodeHandle() {
      if (this.loginUser.phone === "") {
        this.$message.error("手机号不能为空")
        return
      }
      let reg = /^1[3-9]\d{9}$/;
      if (this.loginUser.phone.length === 11) {
        if (!reg.test(this.loginUser.phone)) {
          this.$message.error("请输入正确的手机号")
          return
        }
      } else {
        return
      }
      // 弹出图形验证码
      this.showCaptcha((captchaUuid, captchaCode) => {
        this.getCode = true
        this.sendTime = 60;
        this.getCodeText = "重新发送(" + this.sendTime + ")"
        if (this.timerLogin) clearInterval(this.timerLogin);
        this.timerLogin = setInterval(() => {
          if (this.sendTime > 0) {
            this.sendTime--;
            this.getCodeText = "重新发送(" + this.sendTime + ")"
          } else {
            this.getCode = false;
            this.getCodeText = "获取验证码"
            clearInterval(this.timerLogin);
            this.timerLogin = null;
          }
        }, 1000);
        getUserLoginPhoneCode({
          phone: this.loginUser.phone,
          captchaUuid: captchaUuid,
          captchaCode: captchaCode
        }).then((res) => {
        }).catch(() => {
          this.getCode = false;
          this.getCodeText = "获取验证码"
          if (this.timerLogin) { clearInterval(this.timerLogin); this.timerLogin = null; }
        })
      });
    },

    // 找回密码获取验证码
    getCodeByPassword() {
      if (this.reUser.phone === "") {
        this.$message.error("手机号不能为空")
        return
      }
      var reg = /^1[3-9]\d{9}$/;
      if (this.reUser.phone.length === 11) {
        if (!reg.test(this.reUser.phone)) {
          this.$message.error("请输入正确的手机号")
          return
        }
      } else {
        return
      }
      // 弹出图形验证码
      this.showCaptcha((captchaUuid, captchaCode) => {
        this.getCode1 = true
        this.sendTime = 60;
        this.getCodeText1 = "重新发送(" + this.sendTime + ")"
        if (this.timerPassword) clearInterval(this.timerPassword);
        this.timerPassword = setInterval(() => {
          if (this.sendTime > 0) {
            this.sendTime--;
            this.getCodeText1 = "重新发送(" + this.sendTime + ")"
          } else {
            this.getCode1 = false;
            this.getCodeText1 = "获取验证码"
            clearInterval(this.timerPassword);
            this.timerPassword = null;
          }
        }, 1000);
        getUserLoginPhoneCode({
          phone: this.reUser.phone,
          captchaUuid: captchaUuid,
          captchaCode: captchaCode
        }).then((res) => {
        }).catch(() => {
          this.getCode1 = false;
          this.getCodeText1 = "获取验证码"
          if (this.timerPassword) { clearInterval(this.timerPassword); this.timerPassword = null; }
        })
      });
    },

    //注册时获取验证码
    getCodeInReg(){
      if (this.registerPwdUser.phone === "") {
        this.$message.error("手机号不能为空")
        return
      }
      var reg = /^1[3-9]\d{9}$/;
      if (this.registerPwdUser.phone.length === 11) {
        if (!reg.test(this.registerPwdUser.phone)) {
          this.$message.error("请输入正确的手机号")
          return
        }
      } else {
        return
      }
      // 弹出图形验证码
      this.showCaptcha((captchaUuid, captchaCode) => {
        this.getCode2 = true
        this.sendTime = 60;
        this.getCodeText2 = "重新发送(" + this.sendTime + ")"
        if (this.timerReg) clearInterval(this.timerReg);
        this.timerReg = setInterval(() => {
          if (this.sendTime > 0) {
            this.sendTime--;
            this.getCodeText2 = "重新发送(" + this.sendTime + ")"
          } else {
            this.getCode2 = false;
            this.getCodeText2 = "获取验证码"
            clearInterval(this.timerReg);
            this.timerReg = null;
          }
        }, 1000);
        getUserLoginPhoneCode({
          phone: this.registerPwdUser.phone,
          captchaUuid: captchaUuid,
          captchaCode: captchaCode
        }).then((res) => {
        }).catch(() => {
          this.getCode2 = false;
          this.getCodeText2 = "获取验证码"
          if (this.timerReg) { clearInterval(this.timerReg); this.timerReg = null; }
        })
      });
    },


    changeLoginTypeHangle(index) {
      localStorage.setItem("zhshLoginType", this.loginType[index].type)
      if (this.loginType[index].type == 'wx') {
        getWechatQrCode().then((res) => {
          window.location.href = res.data
        })
        return
      }
      if (this.loginType[index].type == 'qq') {
        this.qc.Login.showPopup(this.options)
        return
      }
      this.changeShow = false
      let oldLoginType = this.loginType[0]
      let newLoginType = this.loginType[index]
      this.loginType[0] = newLoginType
      this.loginType[index] = oldLoginType
      this.currentLoginType = newLoginType.type
      this.changeShow = true
    },

    async PwdLogin() {
      // 通过element自定义表单校验规则，校验用户输入的用户信息
      this.$refs["rulePwdForm"].validate(valid => {
        //如果通过校验开始登录
        if (valid) {
          this.btnLoading = true
          accountPwdLogin(this.loginPwdUser).then((res) => {
            if (res.code === 200) {
              // 隐藏登录组件
              this.isLogin = false;
              // 登录信息存到本地
              res.data.user.accessToken = res.data.token
              res.data.user.avatar = res.data.user.avatar ? (res.data.user.avatar.indexOf('http') >= 0 ? '' : this.$target) + res.data.user.avatar : '/img/head-sculpture.png'
              let user = JSON.stringify(res.data.user);
              localStorage.setItem("user", user);
              this.$emit("getUserNo", res.data.user.userNo)

              // 登录信息存到vuex
              setToken(res.data.token);
              this.setUser(res.data.user);
              // 弹出通知框提示登录成功信息
              this.notifySucceed(res.msg);
              this.$refs["rulePwdForm"].resetFields();
            } else {
              // 清空输入框的校验状态
              this.$refs["rulePwdForm"].resetFields();
              // 弹出通知框提示登录失败信息
              this.notifyError(res.data.msg);
            }
          }).finally(() => {
            this.btnLoading = false
          })
          return true
        } else {
          return false;
        }
      });
    },

    Login() {

      // 通过element自定义表单校验规则，校验用户输入的用户信息
      this.$refs["ruleForm"].validate(valid => {
        //如果通过校验开始登录
        if (valid) {
          this.btnLoading = true
          accountCodeLogin(this.loginUser).then((res) => {
            if (res.code === 200) {
              // 隐藏登录组件
              this.isLogin = false;
              // 登录信息存到本地
              res.data.user.accessToken = res.data.token
              res.data.user.avatar = res.data.user.avatar ? (res.data.user.avatar.indexOf('http') >= 0 ? '' : this.$target) + res.data.user.avatar : '/img/head-sculpture.png'
              let user = JSON.stringify(res.data.user);
              localStorage.setItem("user", user);
              this.$emit("getUserNo", res.data.user.userNo)

              // 登录信息存到vuex
              setToken(res.data.token);
              this.setUser(res.data.user);
              // 弹出通知框提示登录成功信息
              this.notifySucceed(res.msg);
              this.$refs["ruleForm"].resetFields();
            } else {
              // 清空输入框的校验状态
              this.$refs["ruleForm"].resetFields();
              // 弹出通知框提示登录失败信息
              this.notifyError(res.data.msg);
            }
          }).finally(() => {
            this.btnLoading = false
          })
          return true
        } else {
          return false;
        }
      });
    },

    // 找回密码
    rePassword() {
      if (this.reUser.newPassword !== this.reUser.newPassword1){
        return
      }
      PasswordSet(this.reUser).then(res => {
        this.$message({
          message: "重置密码成功",
          type: 'success'
        })
        this.currentLoginType = 'mobile'
      })
    },
  }
};
</script>
<style  lang="scss">
.dialog-login {
  position: relative;
  border-radius: 0.925rem;
  height: 420px;
}
</style>
<style scoped lang="scss">
.dialog-content {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;

  .dialog-content-left {
    width: 12.5rem;
    border-top-left-radius: 0.925rem;
    border-bottom-left-radius: 0.925rem;
    background-image: url(../assets/imgs/bg-login.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .dialog-content-left-name {
      font-size: 1.125rem;
      font-weight: bold;
      color: #FFFFFF;
      padding: 3.25rem 0;
      text-align: center;
    }
  }

  .dialog-content-right {
    width: 25rem;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

.demo-reUser .el-form-item {
  margin-bottom: 18px;
}

/* 图形验证码弹窗 */
.captcha-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.captcha-box {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 160px;
  text-align: center;
}
.captcha-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #333;
}
.captcha-img-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.captcha-img {
  height: 40px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.captcha-refresh {
  color: #409EFF;
  cursor: pointer;
  margin-left: 8px;
  font-size: 12px;
}
.captcha-input {
  margin-bottom: 16px;
}
.captcha-btns {
  display: flex;
  justify-content: space-between;
}

</style>
